export default function sleep(milliseconds: number) {
  return new Promise((resolve) => {
    window.setTimeout(() => resolve(null), milliseconds)
  })
}
